var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"your-plan"},[_c('Margins',[_c('YourPlanTable',{attrs:{"showPaymentAmount":_vm.showPaymentAmount}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }